import React from 'react';

import { AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import { css, styled } from 'styled-components';

import theme from 'styles/theme';

import CtaButton from 'components/CtaButton/CtaButton';
import Flex from 'components/Flex/Flex';

import { AccordionContentI } from 'interfaces/content-stack/modular-blocks/accordion';

import { sanitizeAndUpdatePreviewPaths } from 'utils/textUtils';

const MainContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-family: ${theme.fonts.default};
    font-size: 1rem;
    font-weight: 500;

    img {
      height: auto;
      width: 100%;
    }

    p {
      margin: 0;
      line-height: 1.5rem;
    }

    ul {
      line-height: 1rem;
      margin: 0;
      padding-left: 1rem;

      li {
        &::marker {
          padding-left: 0.5rem;
          color: ${theme.colors.primaryRed};
          font-size: 1.5rem;
        }
      }
    }
  `
);

const StyledAccordionItem = styled(AccordionItem)`
  background-color: transparent !important;

  button {
    background-color: transparent !important;
  }
`;

type Props = {
  accordionItem: AccordionContentI;
  id: string;
};

const Accordion: React.FC<Props> = ({ accordionItem, id }) => {
  const { header, body, ctaButton } = accordionItem;

  return (
    <StyledAccordionItem>
      <AccordionHeader targetId={id}>{header}</AccordionHeader>
      <AccordionBody accordionId={id}>
        <Flex column gap={1.5} styles={{ padding: '1.5rem 0 2rem 0' }}>
          {body && <MainContent dangerouslySetInnerHTML={{ __html: sanitizeAndUpdatePreviewPaths(body) }} />}
          {ctaButton?.buttonText && ctaButton.link && (
            <CtaButton
              to={ctaButton.link[0].linkUrl.href}
              buttonType='link'
              bold
              text={ctaButton.buttonText}
              textColor={theme.colors.primaryBlack2}
              dataLayerInfo={header}
            />
          )}
        </Flex>
      </AccordionBody>
    </StyledAccordionItem>
  );
};

export default Accordion;
